<template>
  <div>
    <v-expansion-panels v-model="configPanels" multiple flat class="calendar-config-panels">
      <v-expansion-panel elevation="0" :class="panelBorderClass">
        <v-expansion-panel-header class="calendar-config-panel-header d-flex align-center justify-start">
          <div class="d-flex align-center justify-start">
            <v-icon class="calendar-config-panel-icon mr-3" color="grey darken-1">mdi-account-check-outline</v-icon>
            <span
              class="calendar-config-panel-title font-roboto text-subtitle-1 font-weight-regular plusGreyDarken2--text">{{
                $t("message.calendar_admin_plus.registration_based_classes")
              }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-0">

          <v-card-text class="pt-0 text-subtitle-1 plusGreyDarken1--text">
            {{ $t('message.calendar_admin_plus.config_registration_intro') }}</v-card-text>
          <div class="pa-2 pt-0 calendar-config-registration-switches">
            <div class="d-flex align-center calendar-config-switch-row">

              <v-switch inset dense color="plusIndigoDarken4"
                class="calendar-config-switch-input flex-shrink-0 mt-0 pt-0" hide-details v-model="showForAll"
                @change="updateCalendarSettings" />
              <div class="calendar-config-switch-label">
                <div class="font-roboto text-subtitle-1  plusGreyDarken1--text">
                  {{ $t('message.calendar_admin_plus.visible_for_all') }}
                </div>
                <div class="supporting-text mt-1 plusGreyDarken1--text text-subtitle-2 font-weight-regular">{{
                  $t('message.calendar_admin_plus.public_calendar_explained') }}</div>
              </div>
            </div>

            <v-switch inset dense color="plusIndigoDarken4" v-show="false" hide-details v-model="showForStudents"
              :label="$t('message.calendar_admin_plus.visible_for_students')"></v-switch>
            <div class="d-flex align-center calendar-config-switch-row">
              <v-switch inset dense color="plusIndigoDarken4"
                class="calendar-config-switch-input flex-shrink-0 mt-0 pt-0" hide-details v-model="skipApproval"
                @change="updateCalendarSettings" />
              <div class="calendar-config-switch-label">
                <div class="font-roboto text-subtitle-1  plusGreyDarken1--text">
                  {{ $t('message.calendar_admin_plus.skip_class_request_approval') }}
                </div>
                <div class="supporting-text mt-1 plusGreyDarken1--text text-subtitle-2 font-weight-regular">{{
                  $t('message.calendar_admin_plus.skip_class_request_approval_explained') }}</div>
              </div>
            </div>
            <div class="d-flex align-center calendar-config-switch-row">
              <v-switch inset dense color="plusIndigoDarken4"
                class="calendar-config-switch-input flex-shrink-0 mt-0 pt-0" hide-details v-model="allowWaitlist"
                @change="updateCalendarSettings" />
              <div class="calendar-config-switch-label">
                <div class="font-roboto text-subtitle-1  plusGreyDarken1--text">
                  {{ $t('message.calendar_admin_plus.allow_waitlist') }}
                </div>
                <div class="supporting-text mt-1 plusGreyDarken1--text text-subtitle-2 font-weight-regular">{{
                  $t('message.calendar_admin_plus.allow_waitlist_explained') }}</div>
              </div>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="0" :class="panelBorderClass">
        <v-expansion-panel-header class="calendar-config-panel-header">
          <div class="d-flex align-center justify-start">
            <v-icon class="calendar-config-panel-icon mr-3" color="grey darken-1">mdi-calendar-month-outline</v-icon>
            <span
              class="calendar-config-panel-title font-roboto text-subtitle-1 font-weight-regular plusGreyDarken2--text">{{
                $t("message.calendar_admin_plus.public_schedule_page") }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-0">
          <div class="supporting-text text-subtitle-1 plusGreyDarken1--text mb-8">{{
            $t('message.calendar_admin_plus.embed_schedule_explained')
          }}</div>
          <v-card-text class="pa-0">

            <v-select hide-details v-model="scheduleMode" :items="scheduleModeItems" item-text="text" item-value="value"
              :label="$t('message.calendar_admin_plus.schedule_display')" outlined dense class="ma-0"></v-select>

            <div class="calendar-config-schedule-embed-switches mt-6">
              <div class="d-flex align-start calendar-config-switch-row">
                <v-switch inset dense color="plusIndigoDarken4"
                  class="calendar-config-switch-input flex-shrink-0 mt-0 pt-0" hide-details v-model="embedMode"
                  @change="refreshCalendarIframe" />
                <div class="calendar-config-switch-label ">
                  <div class="font-roboto text-subtitle-1 plusGreyDarken1--text">
                    {{ $t('message.calendar_admin_plus.hide_logos') }}
                  </div>
                  <div class="supporting-text mt-1 plusGreyDarken1--text text-subtitle-2 font-weight-regular">{{
                    $t('message.calendar_admin_plus.hide_logos_explained') }}</div>
                </div>
              </div>
              <div class="d-flex align-start justify-start calendar-config-switch-row">
                <v-switch inset dense color="plusIndigoDarken4"
                  class="calendar-config-switch-input flex-shrink-0 mt-0 pt-0" hide-details
                  v-model="transparentBackground" @change="refreshCalendarIframe" />
                <div class="calendar-config-switch-label">
                  <div class="font-roboto text-subtitle-1 plusGreyDarken1--text">
                    {{ $t('message.calendar_admin_plus.transparent_background') }}
                  </div>
                  <div class="supporting-text mt-1 plusGreyDarken1--text text-subtitle-2 font-weight-regular">{{
                    $t('message.calendar_admin_plus.transparent_background_explained') }}</div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-text v-if="displayExternalSchedule" id="academy_public_schedule_embed">
            <iframe v-if="publicScheduleUrl" style="width:100%;height:330px" :src="publicScheduleUrl"></iframe>
          </v-card-text>
          <v-card-text class="text-center" v-else>
            <circles-loader></circles-loader>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined v-if="!isSmallerDisplay()" elevation="0" @click="openQrCodeNewPage()">
              <div class="plusGreyDarken1--text font-roboto">
                {{ $t('message.calendar_admin_plus.qr_code') }}
              </div>
            </v-btn>
            <v-btn outlined elevation="0" small @click="copyPublicUrl()">
              <div class="plusGreyDarken1--text font-roboto">
                {{ $t('message.calendar_admin_plus.copy_url') }}
              </div>
            </v-btn>
            <v-btn outlined elevation="0" @click="copyEmbedCode(false)">
              <div class="plusGreyDarken1--text font-roboto">
                {{ $t('message.calendar_admin_plus.copy_embed_code') }}
              </div>
            </v-btn>
          </v-card-actions>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-allowed="'edit_schedule'" elevation="0" :class="panelBorderClass">
        <v-expansion-panel-header class="calendar-config-panel-header">
          <div class="d-flex align-center justify-start">
            <v-icon class="calendar-config-panel-icon mr-3">mdi-clipboard-text-outline</v-icon>
            <span
              class="calendar-config-panel-title font-roboto text-subtitle-1 font-weight-regular plusGreyDarken2--text">{{
                $t('message.calendar_admin_plus.config_public_schedule_note_title') }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-0">

          <div class="supporting-text text-subtitle-1 plusGreyDarken1--text mb-8">{{
            $t('message.calendar_admin_plus.config_public_schedule_note_intro') }}</div>

          <v-card-text class="pa-0">
            <v-avatar size="20" v-if="scheduleNotes && scheduleNotes.user">
              <ImageDisplay v-if="scheduleNotes.user.userImageSmall" :src="scheduleNotes.user.userImageSmall" />
              <img v-else :src="assets('default-profile-avatar.png')" />
            </v-avatar>
            <span class="ml-1" v-if="scheduleNotes && scheduleNotes.user">{{ $t('message.calendar_admin_plus.last_update_by') }}
              {{ scheduleNotes.user.displayName }}</span>
            <span v-if="scheduleNotes && scheduleNotes.user" style="color:gray; margin-left: 10px">{{ $d(new
              Date(scheduleNotes.date), 'short', $i18n.locale) }}</span>
            <v-textarea style="margin-top:10px" rows="3" :auto-grow="true" outlined v-model="scheduleNotes.notes"
              :label="$t('message.calendar_admin_plus.description')"></v-textarea>
            <div class="supportive-text" style="margin-top:-20px">{{ $t('message.calendar_admin_plus.schedule_notes_explained') }}</div>
          </v-card-text>
          <v-card-actions class="pt-0 pb-2">
            <v-spacer></v-spacer>
            <v-btn outlined elevation="0" color="plusGreyDarken1" @click="updateScheduleNotes()">
              <div class="plusGreyDarken1--text font-roboto">
                {{ $t('message.calendar_admin_plus.clear') }}
              </div>
            </v-btn>
            <v-btn elevation="0" @click="updateScheduleNotes('update')" color="plusIndigoDarken2">
              <div class="plusGreyLighten5--text font-roboto">
                {{ $t('message.calendar_admin_plus.update') }}
              </div>
            </v-btn>

          </v-card-actions>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel elevation="0" :class="panelBorderClass">
        <v-expansion-panel-header class="calendar-config-panel-header">
          <div class="d-flex align-center justify-start">
            <v-icon class="calendar-config-panel-icon mr-3" color="grey darken-1">mdi-calendar-check</v-icon>
            <span
              class="calendar-config-panel-title font-roboto text-subtitle-1 font-weight-regular plusGreyDarken2--text">{{
                $t("message.calendar_admin_plus.book_class_public_page") }}</span>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-0">
          <div class="supporting-text text-subtitle-1 plusGreyDarken1--text mb-8">{{
            $t('message.calendar_admin_plus.embed_schedule_visit_explained') }}</div>
          <div class="pa-0 pt-0">
            <div>
              <AvailableClasses :single="true" :label="$t('message.calendar_admin_plus.single_class_calendar')" :vm="this"
                v-model="scheduleClassName">
              </AvailableClasses>
            </div>

            <div class="pt-2 supporting-text text-subtitle-1 plusGreyDarken1--text">{{
              $t('message.calendar_admin_plus.config_single_class_calendar_hint') }}</div>


            <div class="d-flex align-start justify-start calendar-config-switch-row mt-8">
              <v-switch @change="updateCalendarSettings" dense color="plusIndigoDarken4" inset hide-details
                v-model="disablePublicBookClassPage" class="calendar-config-switch-input flex-shrink-0 mt-0 pt-0" />
              <div class="calendar-config-switch-label">
                <div class="font-roboto text-subtitle-1 plusGreyDarken1--text">
                  {{ $t('message.calendar_admin_plus.disable_page') }}
                </div>
                <div class="supporting-text mt-1 plusGreyDarken1--text text-subtitle-2 font-weight-regular">{{
                  $t('message.calendar_admin_plus.config_disable_book_page_explained') }}</div>
              </div>
            </div>

          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined elevation="0" @click="copyPublicUrl(true, true)">
              <div class="plusGreyDarken1--text font-roboto">
                {{ $t('message.calendar_admin_plus.copy_url') }}
              </div>
            </v-btn>
            <v-btn outlined elevation="0" @click="copyEmbedCodeScheduleVisit">
              <div class="plusGreyDarken1--text font-roboto">
                {{ $t('message.calendar_admin_plus.copy_embed_code') }}
              </div>
            </v-btn>
          </v-card-actions>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card elevation="0" v-show="false" outlined class="bjjlink-card">
      <v-card-title>
        {{ $t("message.calendar_admin_plus.public_calendar_page") }}
      </v-card-title>
      <v-card-text>
        <span class="supporting-text">{{ $t('message.calendar_admin_plus.embed_calendar_explained') }}</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn elevation="0" small @click="copyPublicUrl(true)">
          {{ $t('message.calendar_admin_plus.copy_url') }}
        </v-btn>
        <v-btn elevation="0" small @click="copyEmbedCode(true)">
          {{ $t('message.calendar_admin_plus.copy_embed_code') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import ImageDisplay from "@/components/displays/ImageDisplay.vue";
import AvailableClasses from "@/components/inputs/ScheduleClassesCombo.vue";
import Api from "@/services/Api2";
import { Environment } from "@/services/Environment";

export default {
  props: {
    activeTab: {
      type: Number,
      default: 0
    }
  },
  components: {
    CirclesLoader,
    ImageDisplay,
    AvailableClasses
  },
  computed: {
    panelBorderClass() {
      return this.$store.state.theme === "light" ? "border-light" : "border-dark";
    }
  },
  data() {
    return {
      configPanels: [],
      scheduleNotes: {},
      showForAll: false,
      showForStudents: true,
      skipApproval: false,
      allowWaitlist: false,
      disablePublicBookClassPage: false,
      scheduleMode: 'dynamic',
      embedMode: false,
      transparentBackground: false,
      displayExternalSchedule: true,
      publicScheduleUrl: null,
      publicCalendarUrl: null,
      scheduleVisitUrl: null,
      scheduleClassName: null,
      scheduleModeItems: [{ value: 'dynamic', text: this.$t("message.calendar_admin_plus.dynamic") }, { value: 'table', text: this.$t("message.calendar_admin_plus.table") }, { value: 'flat', text: this.$t("message.calendar_admin_plus.flat") }, { value: 'calendar', text: this.$t("message.calendar_admin_plus.calendar") }]
    }
  },
  created() {
    Api()
      .get("admins/academy/" + this.$store.state.selectedAcademy)
      .then((response) => {
        if (response.data.calendarSettings) {
          this.showForAll = response.data.calendarSettings.showForAll;
          this.skipApproval = response.data.calendarSettings.skipApproval;
          this.allowWaitlist = response.data.calendarSettings.allowWaitlist;
          this.showForStudents = true;
          this.disablePublicBookClassPage = response.data.calendarSettings.disablePublicBookClassPage;
        }
      });

    Api()
      .get(
        "admins/academy/" +
        this.$store.state.selectedAcademy +
        "?populate=schedule_notes"
      )
      .then((response) => {
        const baseUrl = Environment.get("VUE_APP_API_HOST");
        this.publicScheduleUrl = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/schedule?';
        this.publicCalendarUrl = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/calendar?';
        this.scheduleVisitUrl = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/calendar?schedule_visit=true';
        this.scheduleNotes =
          response.data.extraFields && response.data.extraFields.scheduleNotes
            ? response.data.extraFields.scheduleNotes
            : {};
        this.$emit('loaded');
      });
  },
  watch: {
    scheduleMode: {
      immediate: false,
      handler: function () {
        this.refreshCalendarIframe();
      },
    },
    showForStudents: {
      immediate: false,
      handler: function () {
        if (!this.showForAll) this.updateCalendarSettings();
      },
    },
  },
  methods: {
    updateCalendarSettings() {
      const data = {
        settings: {
          skipApproval: !this.skipApproval ? false : this.skipApproval,
          allowWaitlist: !this.allowWaitlist ? false : this.allowWaitlist,
          showForAll: !this.showForAll ? false : this.showForAll,
          showForStudents: !this.showForStudents ? false : this.showForStudents,
          disablePublicBookClassPage: !this.disablePublicBookClassPage ? false : this.disablePublicBookClassPage
        },
      };
      Api().patch(
        "calendar/admin/academy/" +
        this.$store.state.managedAcademy +
        "/settings",
        data
      );
    },
    refreshCalendarIframe() {
      if (!this.publicScheduleUrl) return;
      const split = this.publicScheduleUrl.split('?');
      let embedParam = "";
      let transparentBackgroundParam = "";
      let modeParam = "mode=dynamic";
      if (this.scheduleMode)
        modeParam = "mode=" + this.scheduleMode;
      if (this.embedMode)
        embedParam = '&embed=true';
      if (this.transparentBackground)
        transparentBackgroundParam = '&tbg=true';
      this.publicScheduleUrl = split[0] + '?' + modeParam + embedParam + transparentBackgroundParam;
    },
    openQrCodeNewPage() {
      const baseUrl = Environment.get("VUE_APP_API_HOST");
      let urlToCopy = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/schedule?mode=' + this.scheduleMode + (this.embedMode ? '&embed=true' : '') + (this.transparentBackground ? '&tbg=true' : '');
      /*eslint-disable no-undef*/
      let buff = new Buffer(urlToCopy);
      const encodedUrl = buff.toString("base64");
      window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=schedule');
    },
    copyPublicUrl(calendar, schedule) {
      let urlToCopy = this.publicScheduleUrl;
      if (calendar)
        urlToCopy = this.publicCalendarUrl;
      if (schedule) {
        urlToCopy = this.scheduleVisitUrl;
        if (this.scheduleClassName) {
          const encoded = this.encodeBase64(this.scheduleClassName);
          urlToCopy = urlToCopy + '&class=' + encoded;
        }
      }
      this.copyToClipboard(urlToCopy);
    },
    copyEmbedCode(calendar) {
      let url = calendar ? this.publicCalendarUrl : this.publicScheduleUrl;
      let textToCopy = '<iframe style="width:100%;height:330px" frameBorder="0" src="' + (url) + '"></iframe>';
      try {
        navigator.clipboard.writeText(textToCopy);
        this.showAlert("success", this.$t("message.calendar_admin_plus.copied"));
      } catch (err) {
        this.showAlert("error", this.$t("message.calendar_admin_plus.oops_not_working"));
      }
    },
    copyEmbedCodeScheduleVisit() {
      let url = this.scheduleVisitUrl;
      if (this.scheduleClassName) {
        const encoded = this.encodeBase64(this.scheduleClassName);
        url = url + '&class=' + encoded;
      }
      let textToCopy = '<iframe style="width:100%;height:330px" frameBorder="0" src="' + url + '&embed=true"></iframe>';
      try {
        navigator.clipboard.writeText(textToCopy);
        this.showAlert("success", this.$t("message.calendar_admin_plus.copied"));
      } catch (err) {
        this.showAlert("error", this.$t("message.calendar_admin_plus.oops_not_working"));
      }
    },
    updateScheduleNotes(val) {
      let notes = null;
      if (val) notes = this.scheduleNotes.notes;
      else this.scheduleNotes = {};
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/schedule/notes",
          {
            notes: notes,
          }
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.showAlert("success", this.$t("message.calendar_admin_plus.updated"));
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.calendar_admin_plus.error_generic"));
        });
    }
  }
}
</script>

<style scoped>
.calendar-config-panels ::v-deep .v-expansion-panel {
  margin-bottom: 8px !important;
}

.calendar-config-panels ::v-deep .v-expansion-panel:last-child {
  margin-bottom: 0 !important;
}

.calendar-config-panel-header {
  min-height: 48px !important;
}

.calendar-config-panel-header ::v-deep .v-expansion-panel-header__icon .v-icon {
  color: rgba(0, 0, 0, 0.54) !important;
}

.theme--dark .calendar-config-panel-header ::v-deep .v-expansion-panel-header__icon .v-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}


.theme--dark .calendar-config-panel-title {
  color: rgba(255, 255, 255, 0.7);
}

.calendar-config-panels ::v-deep .v-expansion-panel--active .calendar-config-panel-title {
  font-size: 20px !important;
}

.calendar-config-registration-switches .calendar-config-switch-row:not(:last-child),
.calendar-config-schedule-embed-switches .calendar-config-switch-row:not(:last-child) {
  margin-bottom: 24px;
}

.calendar-config-switch-label {
  flex: 1 1 auto;
  min-width: 0;
}

.calendar-config-switch-row ::v-deep .calendar-config-switch-input.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.calendar-config-switch-row ::v-deep .calendar-config-switch-input .v-input__slot {
  margin-bottom: 0;
}
</style>
